import React from 'react';
import classnames from 'classnames';

import AnalyticsLink from '@components/Analytics/AnalyticsLink';

// Styles
import styles from './ButtonPrivacyComponent.module.scss';

// Utils & Helpers
import { getLocalizedContent as l } from '@helpers/languages';

const ButtonPrivacyComponent = ({ data, language }) => (
  <AnalyticsLink
    className={classnames('button', styles.button)}
    to={data.link['en']}
    gaType="footer"
    gaComponent="footer"
  >
    {l(data.title, language)}
  </AnalyticsLink>
);

export default ButtonPrivacyComponent;
